import type { RelyingPartySettingType } from '@/shared/lib/types/relyingParty';
import React from 'react';

export type Setting = string | number | boolean;

export type SettingsContextValue = {
  settings: Record<string, Setting>;
  parseSettingsJsonString: (jsonStr: string) => void;
  companySettings?: RelyingPartySettingType;
  isSecurityPinSet: boolean;
};

const initialValue: SettingsContextValue = {
  parseSettingsJsonString: () => {},
  settings: {},
  companySettings: undefined,
  isSecurityPinSet: false
};

// The provider is in app/composition — it reads session state, which shared cannot.
const SettingsContext = React.createContext<SettingsContextValue>(initialValue);

export default SettingsContext;
